// Contains custom data for our differential amplifiers.
// This file is used to define irregular data, particularly for fixed / programmable gain differential amplifiers or the differential amplifiers used inside our uModules

export let data = {
    "map": {
        // SAR ADCs
        "AD4000" : "AD4000_AD4004_AD4008",
        "AD4001" : "AD4001_AD4003_AD4005_AD4007_AD4011",
        "AD4002" : "AD4002_AD4006_AD4010",
        "AD4003" : "AD4001_AD4003_AD4005_AD4007_AD4011",
        "AD4004" : "AD4000_AD4004_AD4008",
        "AD4005" : "AD4001_AD4003_AD4005_AD4007_AD4011",
        "AD4006" : "AD4002_AD4006_AD4010",
        "AD4007" : "AD4001_AD4003_AD4005_AD4007_AD4011",
        "AD4008" : "AD4000_AD4004_AD4008",
        "AD4010" : "AD4002_AD4006_AD4010",
        "AD4011" : "AD4001_AD4003_AD4005_AD4007_AD4011",
        "AD4020" : "AD4020_AD4021_AD4022",
        "AD4021" : "AD4020_AD4021_AD4022",
        "AD4022" : "AD4020_AD4021_AD4022",
        "AD4695" : "AD4695_AD4696_AD4697_AD4698",
        "AD4696" : "AD4695_AD4696_AD4697_AD4698",
        "AD4697" : "AD4695_AD4696_AD4697_AD4698",
        "AD4698" : "AD4695_AD4696_AD4697_AD4698",
        "AD7380" : "AD7380_AD7381",
        "AD7381" : "AD7380_AD7381",
        "AD7383" : "AD7383_AD7384",
        "AD7384" : "AD7383_AD7384",
        "AD7380-4" : "AD7380-4",
        "AD7381-4" : "AD7381-4",
        "AD7383-4" : "AD7383-4_AD7384-4",
        "AD7384-4" : "AD7383-4_AD7384-4",
        "AD7915" : "AD7915",
        "LTC2380-16" : "LTC2380-16",
        "LTC2387-16" : "LTC2387",
        "LTC2387-18" : "LTC2387",
        "AD4630-24" : "AD4630-24_AD4030-24",
        "AD4630-16" : "AD4630-16",
        "AD4030-24" : "AD4630-24_AD4030-24",
        "AD4632-24" : "AD4632-24_AD4032-24",
        "AD4632-16" : "AD4632-16",
        "AD4032-24" : "AD4632-24_AD4032-24",
        "AD4858"    : "AD4858_AD4857",
        "AD4052"    : "AD4052_AD4050_AD4051_AD4053_AD4054_AD4055",
        "AD7982"    : "AD7982",
        "AD7980"    : "AD7980",
        "AD7981"    : "AD7981",
        "AD7983"    : "AD7983",
        "AD4080"    : "AD4080",
        "ADC40Msps"    : "AD4080", // temporary, to allow customer to preview
        

        // SAR uModules
        "ADAQ4001"  : "ADAQ4001_ADAQ4003",
        "ADAQ4003"  : "ADAQ4001_ADAQ4003",
        "ADAQ4380-4"  : "ADAQ4380-4",
        "ADAQ23875"  : "ADAQ23875_ADAQ23876",
        "ADAQ23876"  : "ADAQ23875_ADAQ23876",
        "ADAQ23878"  : "ADAQ23878",


        // Sigma-Delta ADCs
        "AD4129-8"  : "AD4129-8",
        "AD4130-8"  : "AD4130-8",
        "AD4131-8"  : "AD4131-8",
        "AD4134"    : "AD4134",
        "AD7172-2"  : "AD7172-2",
        "AD7172-4"  : "AD7172-4",
        "AD7173-8"  : "AD7173-8",
        "AD7175-2"  : "AD7175-2",
        "AD7175-8"  : "AD7175-8",
        "AD7177-2"  : "AD7177-2",
        "AD7768-1"  : "AD7768-1",

        // Sigma-Delta uModules
        "ADAQ7768-1": "ADAQ7768-1"
        
    },
    "partData": {
        "AD7982": {
            requiredSupplyPins : [
                'VDD',
                'VIO'
            ],
            inputRange: {
                absolute: {
                    min: {
                        delta    : -0.1,
                        referredTo: 'GND'
                    },
                    max: {
                        delta    : 0.1,
                        referredTo: 'VREF'
                    }
                },
                commonMode: {
                    min: {
                        multiplier  : 0.475,
                        referredTo  : 'VREF'
                    },
                    max: {
                        multiplier  : 0.525,
                        referredTo  : 'VREF'
                    },
                },
            },
            supplyCurrent: [
                {
                    userConfig: {},
                    data : {
                        'VDD' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 10e3, 1e6 ],
                            yValues: [ 350e-9, 15.238e-6, 1.524e-3 ]
                        },
                        'VIO' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 10e3, 1e6 ],
                            yValues: [ 0, 4.333e-6, 433.3e-6 ]
                        },
                        'REF' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 10e3, 1e6 ],
                            yValues: [ 0, 3.4e-6, 340e-6 ]
                        }
                    }
                }
            ],
        },
        "AD7980": {
            requiredSupplyPins : [
                'VDD',
                'VIO'
            ],
            inputRange: {
                absolute: {
                    min: {
                        delta    : -0.1,
                        referredTo: 'GND'
                    },
                    max: {
                        delta    : 0.1,
                        referredTo: 'VREF'
                    }
                },
            },
            supplyCurrent : [
                {
                    userConfig: {},
                    data: {
                        'VDD' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 10e3, 1e6 ],
                            yValues: [ 350e-9, 15.238e-6, 1.524e-3 ]
                        },
                        'VIO' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 10e3, 1e6 ],
                            yValues: [ 0, 4.333e-6, 433.3e-6 ]
                        },
                        'REF' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 10e3, 1e6 ],
                            yValues: [ 0, 3.4e-6, 340e-6 ]
                        }
                    }
                },
            ]
        },
        "AD7981": {
            requiredSupplyPins : [
                'VDD',
                'VIO'
            ],
            inputRange: {
                absolute: {
                    min: {
                        delta    : -0.1,
                        referredTo: 'GND'
                    },
                    max: {
                        delta    : 0.1,
                        referredTo: 'VREF'
                    }
                },
            },
            supplyCurrent : [
                {
                    userConfig: {},
                    data: {
                        'VDD' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 10e3, 600e3 ],
                            yValues: [ 350e-9, 14.286e-6, 857.143e-6 ]
                        },
                        'VIO' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 10e3, 600e3 ],
                            yValues: [ 0, 5e-6, 300e-6 ]
                        },
                        'REF' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 10e3, 600e3 ],
                            yValues: [ 0, 5e-6, 300e-6 ]
                        }
                    }
                },
            ]
        },
        "AD7983": {
            requiredSupplyPins : [
                'VDD',
                'VIO'
            ],
            inputRange: {
                absolute: {
                    min: {
                        delta    : -0.1,
                        referredTo: 'GND'
                    },
                    max: {
                        delta    : 0.1,
                        referredTo: 'VREF'
                    }
                },
            },
            supplyCurrent : [
                {
                    userConfig: {},
                    data: {
                        'VDD' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 10e3, 1.33e6 ],
                            yValues: [ 350e-9, 14.7e-6, 1.955e-3 ]
                        },
                        'VIO' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 10e3, 1.33e6 ],
                            yValues: [ 0, 5e-6, 665e-6 ]
                        },
                        'REF' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 10e3, 1.33e6 ],
                            yValues: [ 0, 5e-6, 665e-6 ]
                        }
                    }
                },
            ]
        },
        "AD4000_AD4004_AD4008": {
            requiredSupplyPins : [
                'VDD',
                'VIO'
            ],
            inputRange: {
                absolute: {
                    min: {
                        delta    : -0.1,
                        referredTo: 'GND'
                    },
                    max: {
                        delta    : 0.1,
                        referredTo: 'VREF'
                    }
                },
            },
            supplyCurrent : [
                {
                    userConfig: { hiZ : 'off' },
                    data: {
                        'VDD' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues : [ 0, 500e3, 1e6, 2e6 ],
                            yValues : [ 1.14e-6, 1.39e-3, 2.72e-3, 5.42e-3 ]
                        },
                        'VIO' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 500e3, 1e6, 2e6 ],
                            yValues: [ 0.05e-6, 55.6e-6, 111.1e-6, 277.8e-6 ]
                        },
                        'REF' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 500e3, 1e6, 2e6 ],
                            yValues: [ 0.4e-6, 180e-6, 380e-6, 750e-6 ]
                        }
                    }
                },
                {
                    userConfig: { hiZ : 'on' },
                    data: {
                        'VDD' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues : [ 0, 500e3, 1e6, 2e6 ],
                            yValues : [ 1.3e-6, 1.59e-3, 3.11e-3, 6.19e-3 ]
                        },
                        'VIO' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 500e3, 1e6, 2e6 ],
                            yValues: [ 0.057e-6, 63.5e-6, 127e-6, 317.5e-6 ]
                        },
                        'REF' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 500e3, 1e6, 2e6 ],
                            yValues: [ 0.457e-6, 205.7e-6, 434.3e-6, 857.1e-6 ]
                        }
                    }
                }
            ]
        },
        "AD4001_AD4003_AD4005_AD4007_AD4011": {
            requiredSupplyPins : [
                'VDD',
                'VIO'
            ],
            inputRange: {
                absolute: {
                    min: {
                        delta    : -0.1,
                        referredTo: 'GND'
                    },
                    max: {
                        delta    : 0.1,
                        referredTo: 'VREF'
                    }
                },
                commonMode: {
                    min: {
                        delta    : -0.125,
                        multiplier: 0.5,
                        referredTo: 'VREF'
                    },
                    max: {
                        delta    : 0.125,
                        multiplier: 0.5,
                        referredTo: 'VREF'
                    }
                },
            },
            supplyCurrent: [
                {
                    userConfig: { hiZ: 'off' },
                    data: {
                        'VDD' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 1e6, 2e6 ],
                            yValues: [ 0.97e-6, 2.72e-3, 5.28e-3 ]
                        },
                        'VIO' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 1e6, 2e6 ],
                            yValues: [ 0.079e-6, 222.2e-6, 555.6e-6 ]
                        },
                        'REF' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 1e6, 2e6 ],
                            yValues: [ 0.553e-6, 560e-6, 1.1e-3 ]
                        }
                    },
                },
                {
                    userConfig: { hiZ: 'on' },
                    data : {
                        'VDD' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 1e6, 2e6 ],
                            yValues: [ 1.21e-6, 3.4e-3, 6.6e-3 ]
                        },
                        'VIO' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 1e6, 2e6 ],
                            yValues: [ 0.099e-6, 277.8e-6, 694.5e-6 ]
                        },
                        'REF' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 1e6, 2e6 ],
                            yValues: [ 0.691e-6, 700e-6, 1.375e-3 ]
                        }
                    }
                }
            ],
        },
        "AD4002_AD4006_AD4010": {
            requiredSupplyPins : [
                'VDD',
                'VIO'
            ],
            inputRange: {
                absolute: {
                    min: {
                        delta    : -0.1,
                        referredTo: 'GND'
                    },
                    max: {
                        delta    : 0.1,
                        referredTo: 'VREF'
                    }
                },
            },
            supplyCurrent: [
                {
                    userConfig: { hiZ: 'off' },
                    data: {
                        'VDD' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 500e3, 1e6, 2e6 ],
                            yValues: [ 1.14e-6, 1.39e-3, 2.72e-3, 5.42e-3 ]
                        },
                        'VIO' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 500e3, 1e6, 2e6 ],
                            yValues: [ 0.05e-6, 55.6e-6, 111.1e-6, 333.4e-6 ]
                        },
                        'REF' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 500e3, 1e6, 2e6 ],
                            yValues: [ 0.4e-6, 190e-6, 380e-6, 730e-6 ]
                        }
                    },
                },
                {
                    userConfig: { hiZ: 'on' },
                    data : {
                        'VDD' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 500e3, 1e6, 2e6 ],
                            yValues: [ 1.24e-6, 1.51e-3, 2.95e-3, 5.88e-3 ]
                        },
                        'VIO' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 500e3, 1e6, 2e6 ],
                            yValues: [ 0.054e-6, 60.4e-6, 120.6e-6, 362e-6 ]
                        },
                        'REF' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 500e3, 1e6, 2e6 ],
                            yValues: [ 0.44e-6, 206e-6, 412.6e-6, 792.6e-6 ]
                        }
                    }
                }
            ],
        },
        "AD4020_AD4021_AD4022": {
            requiredSupplyPins : [
                'VDD',
                'VIO'
            ],
            inputRange: {
                absolute: {
                    min: {
                        delta    : -0.1,
                        referredTo: 'GND'
                    },
                    max: {
                        delta    : 0.1,
                        referredTo: 'VREF'
                    }
                },
                commonMode: {
                    min: {
                        delta    : -0.125,
                        multiplier: 0.5,
                        referredTo: 'VREF'
                    },
                    max: {
                        delta    : 0.125,
                        multiplier: 0.5,
                        referredTo: 'VREF'
                    }
                },
            },
            supplyCurrent: [
                {
                    userConfig: { hiZ: 'off' },
                    data: {
                        'VDD' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 500e3, 1e6, 1.8e6 ],
                            yValues: [ 0.97e-6, 1.5e-3, 2.83e-3, 5e-3 ]
                        },
                        'VIO' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 500e3, 1e6, 1.8e6 ],
                            yValues: [ 0.076e-6, 72.2e-6, 222.2e-6, 555.6e-6 ]
                        },
                        'REF' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 500e3, 1e6, 1.8e6 ],
                            yValues: [ 0.552e-6, 320e-6, 580e-6, 1e-3 ]
                        }
                    },
                },
                {
                    userConfig: { hiZ: 'on' },
                    data : {
                        'VDD' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 500e3, 1e6, 1.8e6 ],
                            yValues: [ 0.97e-6, 1.9e-3, 3.68e-3, 6.33e-3 ]
                        },
                        'VIO' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 500e3, 1e6, 1.8e6 ],
                            yValues: [ 0.076e-6, 91.5e-6, 289.1e-6, 703.4e-6 ]
                        },
                        'REF' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 500e3, 1e6, 1.8e6 ],
                            yValues: [ 0.552e-6, 405e-6, 754.7e-6, 1.267e-3 ]
                        }
                    }
                }
            ],
        },
        "AD4695_AD4696_AD4697_AD4698": {
            requiredSupplyPins : [
                'AVDD',
                'VIO'
            ],
            inputRange: {
                absolute: {
                    min: {
                        delta    : -0.1,
                        referredTo: 'GND'
                    },
                    max: {
                        delta    : 0.1,
                        referredTo: 'VREF'
                    }
                },
            },
            supplyCurrent : [
                {
                    userConfig: { hiZ : 'off', ldo: 'off' },
                    data: {
                        'AVDD' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 10e3, 500e3, 1e6 ],
                            yValues: [ 0.16e-6, 0.68e-6, 26e-6, 52e-6 ]
                        },
                        'VDD' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 10e3, 500e3, 1e6 ],
                            yValues: [ 1.5e-6, 42e-6, 2e-3, 4e-3 ]
                        },
                        'VIO' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 10e3, 500e3, 1e6 ],
                            yValues: [ 0.25e-6, 3.5e-6, 162e-6, 325e-6 ]
                        },
                        'REF' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 10e3, 500e3, 1e6 ],
                            yValues: [ 0.165e-6, 3.3e-6, 160e-6, 320e-6 ]
                        }
                    }
                },
                {
                    userConfig: { hiZ : 'on', ldo: 'off' },
                    data: {
                        'AVDD' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 10e3, 500e3, 1e6 ],
                            yValues: [ 0.16e-6, 13e-6, 0.64e-3, 1.28e-3 ]
                        },
                        'VDD' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 10e3, 500e3, 1e6 ],
                            yValues: [ 1.5e-6, 53e-6, 2.5e-3, 5e-3 ]
                        },
                        'VIO' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 10e3, 500e3, 1e6 ],
                            yValues: [ 0.25e-6, 3.5e-6, 162e-6, 325e-6 ]
                        },
                        'REF' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 10e3, 500e3, 1e6 ],
                            yValues: [ 0.165e-6, 0.3e-6, 6e-6, 12e-6 ]
                        }
                    }
                },
                {
                    userConfig: { hiZ : 'off', ldo: 'on' },
                    data: {
                        'AVDD' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 10e3, 500e3, 1e6 ],
                            yValues: [ 0.16e-6, 0.68e-6, 26e-6, 52e-6 ]
                        },
                        'LDO_IN' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 10e3, 500e3, 1e6 ],
                            yValues: [ 9e-6, 64e-6, 2.6e-3, 5.2e-3 ]
                        },
                        'VIO' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 10e3, 500e3, 1e6 ],
                            yValues: [ 0.25e-6, 3.5e-6, 162e-6, 325e-6 ]
                        },
                        'REF' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 10e3, 500e3, 1e6 ],
                            yValues: [ 0.165e-6, 3.3e-6, 160e-6, 320e-6 ]
                        }
                    }
                },
                {
                    userConfig: { hiZ : 'on', ldo: 'on' },
                    data: {
                        'AVDD' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 10e3, 500e3, 1e6 ],
                            yValues: [ 0.16e-6, 13e-6, 0.64e-3, 1.28e-3 ]
                        },
                        'LDO_IN' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 10e3, 500e3, 1e6 ],
                            yValues: [ 9e-6, 64e-6, 2.6e-3, 5.2e-3 ]
                        },
                        'VIO' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 10e3, 500e3, 1e6 ],
                            yValues: [ 0.25e-6, 3.5e-6, 162e-6, 325e-6 ]
                        },
                        'REF' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 10e3, 500e3, 1e6 ],
                            yValues: [ 0.165e-6, 0.3e-6, 6e-6, 12e-6 ]
                        }
                    }
                },
            ]
        },
        "AD7380_AD7381": {
            requiredSupplyPins : [
                'VCC',
                'VLOGIC'
            ],
            inputRange: {
                absolute: {
                    min: {
                        delta    : -0.1,
                        referredTo: 'GND'
                    },
                    max: {
                        delta    : 0.1,
                        referredTo: 'VREF'
                    }
                },
                commonMode: {
                    min: {
                        delta    : 0.2,
                        referredTo: 'GND'
                    },
                    max: {
                        delta    : -0.2,
                        referredTo: 'VREF'
                    }
                },
            },
            supplyCurrent : [
                {
                    userConfig: {},
                    data: {
                        'VCC' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 4e6 ],
                            yValues: [ 2.3e-3, 21.5e-3 ]
                        },
                        'VLOGIC' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 4e6 ],
                            yValues: [ 10e-9, 3.5e-3 ]
                        },
                        'REF' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 4e6 ],
                            yValues: [ 0, 470e-6 ]
                        }
                    }
                },
            ]
        },
        "AD7383_AD7384": {
            requiredSupplyPins : [
                'VCC',
                'VLOGIC'
            ],
            inputRange: {
                absolute: {
                    min: {
                        delta    : -0.1,
                        referredTo: 'GND'
                    },
                    max: {
                        delta    : 0.1,
                        referredTo: 'VREF'
                    }
                },
            },
            supplyCurrent : [
                {
                    userConfig: {},
                    data: {
                        'VCC' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 4e6 ],
                            yValues: [ 2.3e-3, 22.5e-3 ]
                        },
                        'VLOGIC' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 4e6 ],
                            yValues: [ 10e-9, 3.5e-3 ]
                        },
                        'REF' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 4e6 ],
                            yValues: [ 0, 470e-6 ]
                        }
                    }
                },
            ]
        },
        "AD7380-4": {
            requiredSupplyPins : [
                'VCC',
                'VLOGIC'
            ],
            inputRange: {
                absolute: {
                    min: {
                        delta    : -0.1,
                        referredTo: 'GND'
                    },
                    max: {
                        delta    : 0.1,
                        referredTo: 'VREF'
                    }
                },
                commonMode: {
                    min: {
                        delta    : 0.2,
                        referredTo: 'GND'
                    },
                    max: {
                        delta    : -0.2,
                        referredTo: 'VREF'
                    }
                },
            },
            supplyCurrent : [
                {
                    userConfig: {},
                    data: {
                        'VCC' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 4e6 ],
                            yValues: [ 1.7e-3, 38e-3 ]
                        },
                        'VLOGIC' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 4e6 ],
                            yValues: [ 10e-9, 7.3e-3 ]
                        },
                        'REF' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 4e6 ],
                            yValues: [ 0, 0.9e-3 ]
                        }
                    }
                },
            ]
        },
        "AD7381-4": {
            requiredSupplyPins : [
                'VCC',
                'VLOGIC'
            ],
            inputRange: {
                absolute: {
                    min: {
                        delta    : -0.1,
                        referredTo: 'GND'
                    },
                    max: {
                        delta    : 0.1,
                        referredTo: 'VREF'
                    }
                },
                commonMode: {
                    min: {
                        delta    : 0.2,
                        referredTo: 'GND'
                    },
                    max: {
                        delta    : -0.2,
                        referredTo: 'VREF'
                    }
                },
            },
            supplyCurrent : [
                {
                    userConfig: {},
                    data: {
                        'VCC' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 4e6 ],
                            yValues: [ 1.7e-3, 38e-3 ]
                        },
                        'VLOGIC' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 4e6 ],
                            yValues: [ 10e-9, 7.3e-3 ]
                        },
                        'REF' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 4e6 ],
                            yValues: [ 0, 0.9e-3 ]
                        }
                    }
                },
            ]
        },
        "AD7383-4_AD7384-4": {
            requiredSupplyPins : [
                'VCC',
                'VLOGIC'
            ],
            inputRange: {
                absolute: {
                    min: {
                        delta    : -0.1,
                        referredTo: 'GND'
                    },
                    max: {
                        delta    : 0.1,
                        referredTo: 'VREF'
                    }
                },
                commonMode: {
                    min: {
                        delta    : 0.2,
                        referredTo: 'GND'
                    },
                    max: {
                        delta    : -0.2,
                        referredTo: 'VREF'
                    }
                },
            },
            supplyCurrent : [
                {
                    userConfig: {},
                    data: {
                        'VCC' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 4e6 ],
                            yValues: [ 2.6e-3, 39e-3 ]
                        },
                        'VLOGIC' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 4e6 ],
                            yValues: [ 155e-9, 7.6e-3 ]
                        },
                        'REF' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 4e6 ],
                            yValues: [ 0, 0.91e-3 ]
                        }
                    }
                },
            ]
        },
        "AD7915": {
            requiredSupplyPins : [
                'VDD',
                'VIO'
            ],
            inputRange: {
                absolute: {
                    min: {
                        delta    : -0.1,
                        referredTo: 'GND'
                    },
                    max: {
                        delta    : 0.1,
                        referredTo: 'VREF'
                    }
                },
                commonMode: {
                    min: {
                        multiplier  : 0.475,
                        referredTo  : 'VREF'
                    },
                    max: {
                        multiplier  : 0.525,
                        referredTo  : 'VREF'
                    }
                },
            },
            supplyCurrent : [
                {
                    userConfig: {},
                    data: {
                        'VDD' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 1e6 ],
                            yValues: [ 200e-9, 1.524e-3 ]
                        },
                        'VIO' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 1e6 ],
                            yValues: [ 65e-9, 433e-6 ]
                        },
                        'REF' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 1e6 ],
                            yValues: [ 85e-9, 340e-6 ]
                        }
                    }
                },
            ]
        },
        "LTC2380-16": {
            requiredSupplyPins : [
                'VDD',
                'OVDD',
            ],
            inputRange: {
                absolute: {
                    min: {
                        delta    : -0.05,
                        referredTo: 'GND'
                    },
                    max: {
                        delta    : 0.05,
                        referredTo: 'VREF'
                    }
                },
                commonMode: {
                    min: {
                        delta    : -0.1,
                        multiplier: 0.5,
                        referredTo: 'VREF'
                    },
                    max: {
                        delta    : 0.1,
                        multiplier: 0.5,
                        referredTo: 'VREF'
                    }
                },
            },
            supplyCurrent : [
                {
                    userConfig: {},
                    data: {
                        'VDD' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 2e6 ],
                            yValues: [ 690e-9, 7.5e-3 ]
                        },
                        'OVDD' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 2e6 ],
                            yValues: [ 101e-9, 1.1e-3 ]
                        },
                        'REF' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 2e6 ],
                            yValues: [ 110e-9, 1.2e-3 ]
                        }
                    }
                },
            ]
        },
        "LTC2387": {
            requiredSupplyPins : [
                'VDD',
                'VDDL',
                'OVDD'
            ],
            inputRange: {
                absolute: {
                    min: {
                        delta    : -0.1,
                        referredTo: 'GND'
                    },
                    max: {
                        delta    : 0.1,
                        referredTo: 'VREF'
                    }
                },
                commonMode: {
                    min: {
                        delta    : -0.1,
                        multiplier: 0.5,
                        referredTo: 'VREF'
                    },
                    max: {
                        delta    : 0.1,
                        multiplier: 0.5,
                        referredTo: 'VREF'
                    }
                },
            },
            supplyCurrent : [
                {
                    userConfig: {},
                    data: {
                        'VDD' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 15e6 ],
                            yValues: [ 2e-3, 5e-3 ]
                        },
                        'VDDL' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 15e6 ],
                            yValues: [ 27e-3, 31.4e-3 ]
                        },
                        'OVDD' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 15e6 ],
                            yValues: [ 8e-3, 8.8e-3 ]
                        },
                        'REF' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 15e6 ],
                            yValues: [ 0.5e-3, 1.6e-3 ]
                        }
                    }
                },
            ]
        },
        "AD4630-24_AD4030-24": {
            requiredSupplyPins : [
                'VDD_5V',
                'VDD_1.8V',
                'VIO'
            ],
            inputRange: {
                absolute: {
                    min: {
                        multiplier : -0.007813,
                        referredTo : 'VREF'
                    },
                    max: {
                        multiplier : 1.0078125,
                        referredTo : 'VREF'
                    }
                },
                commonMode: {
                    min: {
                        multiplier : -0.007813,
                        referredTo : 'VREF'
                    },
                    max: {
                        multiplier : 1.0078125,
                        referredTo : 'VREF'
                    }
                },
            },
            supplyCurrent : [
                {
                    userConfig: {},
                    data: {
                        'VDD_5V' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 2e6 ],
                            yValues: [ 500e-6, 2.7e-3 ]
                        },
                        'VDD_1.8V' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 2e6 ],
                            yValues: [ 90e-6, 8.2e-3 ]
                        },
                        'VIO' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 2e6 ],
                            yValues: [ 1e-6, 0.6e-3 ]
                        },
                        'REF' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 2e6 ],
                            yValues: [ 0, 1.8e-6 ]
                        }
                    }
                },
            ],
            userConfig: [
                {
                    option: { refBuff: 'off'},
                    dcErrors: {
                        'fullScaleErrorAtMaxTemp': 671,    //lsbs
                        'fullScaleErrorDrift' : 25e-3,
                    }
                },
                {
                    option: { refBuff: 'on'},
                    dcErrors: {
                        'fullScaleErrorAtMaxTemp': 1.342e3, //lsbs, twice as much as when ref buff is off
                        'fullScaleErrorDrift': 70e-3,
                        // custom parameters for reference buffer - not in pdb
                        'RefIbias': 5e-9,
                        'RefIbiasAtMaxTemp': 50e-9,
                        'RefBufferOffset': 25e-6, //volts
                        'RefBufferDrift': 0.3e-6, // Volts / degrees C
                    }
                },

            ]
        },
        "AD4630-16": {
            requiredSupplyPins : [
                'VDD_5V',
                'VDD_1.8V',
                'VIO'
            ],
            inputRange: {
                absolute: {
                    min: {
                        multiplier : -0.007813,
                        referredTo : 'VREF'
                    },
                    max: {
                        multiplier : 1.0078125,
                        referredTo : 'VREF'
                    }
                },
                commonMode: {
                    min: {
                        multiplier : -0.007813,
                        referredTo : 'VREF'
                    },
                    max: {
                        multiplier : 1.0078125,
                        referredTo : 'VREF'
                    }
                },
            },
            supplyCurrent : [
                {
                    userConfig: {},
                    data: {
                        'VDD_5V' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 2e6 ],
                            yValues: [ 500e-6, 2.7e-3 ]
                        },
                        'VDD_1.8V' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 2e6 ],
                            yValues: [ 90e-6, 8.2e-3 ]
                        },
                        'VIO' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 2e6 ],
                            yValues: [ 1e-6, 0.6e-3 ]
                        },
                        'REF' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 2e6 ],
                            yValues: [ 0, 1.8e-6 ]
                        }
                    }
                },
            ],
            userConfig: [
                {
                    option: { refBuff: 'off'},
                    dcErrors: {
                        'fullScaleErrorAtMaxTemp': 3.275,    //lsbs
                        'fullScaleErrorDrift' : 50e-3,
                    }
                },
                {
                    option: { refBuff: 'on'},
                    dcErrors: {
                        'fullScaleErrorAtMaxTemp': 6.55, //lsbs, twice as much as when ref buff is off
                        'fullScaleErrorDrift': 100e-3,
                        // custom parameters for reference buffer - not in pdb
                        'RefIbias': 5e-9,
                        'RefIbiasAtMaxTemp': 50e-9,
                        'RefBufferOffset': 25e-6, //volts
                        'RefBufferDrift': 0.3e-6, // Volts / degrees C
                    }
                },
            ]
        },
        "AD4632-24_AD4032-24": {
            requiredSupplyPins : [
                'VDD_5V',
                'VDD_1.8V',
                'VIO'
            ],
            inputRange: {
                absolute: {
                    min: {
                        multiplier : -0.007813,
                        referredTo : 'VREF'
                    },
                    max: {
                        multiplier : 1.0078125,
                        referredTo : 'VREF'
                    }
                },
                commonMode: {
                    min: {
                        multiplier : -0.007813,
                        referredTo : 'VREF'
                    },
                    max: {
                        multiplier : 1.0078125,
                        referredTo : 'VREF'
                    }
                },
            },
            supplyCurrent : [
                {
                    userConfig: {},
                    data: {
                        'VDD_5V' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 500e3 ],
                            yValues: [ 500e-6, 1.1e-3 ]
                        },
                        'VDD_1.8V' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 500e3 ],
                            yValues: [ 90e-6, 2.1e-3 ]
                        },
                        'VIO' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 500e3 ],
                            yValues: [ 1e-6, 0.15e-3 ]
                        },
                        'REF' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 500e3 ],
                            yValues: [ 0, 0.5e-6 ]
                        }
                    }
                },
            ],
            userConfig: [
                {
                    option: { refBuff: 'off'},
                    dcErrors: {
                        'fullScaleErrorAtMaxTemp': 671,    //lsbs
                        'fullScaleErrorDrift' : 25e-3,
                    }
                },
                {
                    option: { refBuff: 'on'},
                    dcErrors: {
                        'fullScaleErrorAtMaxTemp': 1.342e3, //lsbs, twice as much as when ref buff is off
                        'fullScaleErrorDrift': 70e-3,
                        // custom parameters for reference buffer - not in pdb
                        'RefIbias': 5e-9,
                        'RefIbiasAtMaxTemp': 50e-9,
                        'RefBufferOffset': 25e-6, //volts
                        'RefBufferDrift': 0.3e-6, // Volts / degrees C
                    }
                },
            ]
        },
        "AD4632-16": {
            requiredSupplyPins : [
                'VDD_5V',
                'VDD_1.8V',
                'VIO'
            ],
            inputRange: {
                absolute: {
                    min: {
                        multiplier : -0.007813,
                        referredTo : 'VREF'
                    },
                    max: {
                        multiplier : 1.0078125,
                        referredTo : 'VREF'
                    }
                },
                commonMode: {
                    min: {
                        multiplier : -0.007813,
                        referredTo : 'VREF'
                    },
                    max: {
                        multiplier : 1.0078125,
                        referredTo : 'VREF'
                    }
                },
            },
            supplyCurrent : [
                {
                    userConfig: {},
                    data: {
                        'VDD_5V' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 500e3 ],
                            yValues: [ 500e-6, 1.1e-3 ]
                        },
                        'VDD_1.8V' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 500e3 ],
                            yValues: [ 90e-6, 2.1e-3 ]
                        },
                        'VIO' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 500e3 ],
                            yValues: [ 1e-6, 0.15e-3 ]
                        },
                        'REF' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 500e3 ],
                            yValues: [ 0, 0.5e-6 ]
                        }
                    }
                },
            ],
            userConfig: [
                {
                    option: { refBuff: 'off'},
                    dcErrors: {
                        'fullScaleErrorAtMaxTemp': 3.275,    //lsbs
                        'fullScaleErrorDrift' : 50e-3,
                    }
                },
                {
                    option: { refBuff: 'on'},
                    dcErrors: {
                        'fullScaleErrorAtMaxTemp': 6.55,    //lsbs
                        'fullScaleErrorDrift' : 100e-3,
                        'RefIbias': 5e-9,
                        'RefIbiasAtMaxTemp': 50e-9,
                        'RefBufferOffset': 25e-6, //volts
                        'RefBufferDrift': 0.3e-6 // Volts / degrees C
                    }
                },
            ]
        },
        "AD4858_AD4857": {
            internalReference: {
                vOut:   4.096,
            },
            internalReferenceBuffer : {
                gain:   1,
            },
            requiredSupplyPins : [
                'VCC',
                'VDD',
                'VIO',
                'VEE'
            ],
            inputRange: {
                absolute: {
                    min: {
                        delta : 3.2,
                        referredTo : 'VEE'
                    },
                    max: {
                        delta : -3.2,
                        referredTo : 'VCC'
                    }
                },
                commonMode: {
                    min: {
                        delta : 3.2,
                        referredTo : 'VEE'
                    },
                    max: {
                        delta : -3.2,
                        referredTo : 'VCC'
                    }
                },
            },
            supplyCurrentMap : {
                // Power supply name : AFM Result key
                "VCC" : "ivcc",
                "VDD" : "ivdd",
                "VDDH" : "ivddh",
                "VDDL" : "ivddl",
                "VEE" : "ivee",
                "VIO" : "ivio",
            },
            userConfig : [
            ]
        },
        "AD4052_AD4050_AD4051_AD4053_AD4054_AD4055": {
            requiredSupplyPins : [
                'VDD',
                'VIO'
            ],
            inputRange: {
                absolute: {
                    min: {
                        delta : -0.1,
                        referredTo : 'GND'
                    },
                    max: {
                        delta : 0.1,
                        referredTo : 'VDD'
                    }
                },
                commonMode: {
                    min: {
                        delta : -0.1,
                        referredTo : 'GND'
                    },
                    max: {
                        delta : 0.1,
                        referredTo : 'VDD'
                    }
                },
            },
            supplyCurrent : [
                {
                    userConfig: {},
                    data: {
                        'VDD' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 10e3, 1e6, 1.5e6, 2e6 ],
                            yValues: [ 990e-9, 5.3e-6, 0.4e-3, 0.6e-3, 0.8e-3 ]
                        },
                        'VIO' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 2e6 ],
                            yValues: [ 260e-9, 260e-9 ]
                        },
                    }
                }
            ]
        },
        "AD4080": {
            requiredSupplyPins : [
                'VDD33'
            ],
            inputRange: {
                absolute: {
                    min: {
                        delta : -0.1,
                        referredTo : 'GND'
                    },
                    max: {
                        delta : 0.1,
                        referredTo : 'VDD33'
                    }
                },
                commonMode: {
                    min: {
                        delta    : -0.05,
                        multiplier: 0.5,
                        referredTo: 'VREF'
                    },
                    max: {
                        delta    : 0.05,
                        multiplier: 0.5,
                        referredTo: 'VREF'
                    }
                },
            },
            supplyCurrent : [
                {
                    userConfig: { ldo: "off" },
                    data: {
                        'VDD33' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 40e6 ],
                            yValues: [ 5.4e-3, 15.7e-3 ]
                        },
                        'VDD11' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 40e6 ],
                            yValues: [ 15.3e-3, 23.2e-3 ]
                        },
                        'IOVDD' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 40e6 ],
                            yValues: [ 5.2e-3, 6e-3 ]
                        },
                    }
                },
                {
                    userConfig: { ldo: "on" },
                    data: {
                        'VDD33' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 40e6 ],
                            yValues: [ 5.4e-3, 15.7e-3 ]
                        },
                        'VDDLDO' : {
                            dataFormat: "x-y values",
                            xUnits: "Samples/sec",
                            yUnits: "A",
                            xValues: [ 0, 40e6 ],
                            yValues: [ 21.5e-3, 29.8e-3 ]
                        }
                    }
                }
            ]
        },
        // SAR uModules:
        "ADAQ4001_ADAQ4003" : {
            requiredSupplyPins : [
                'VS+',
                'VS-',
                'VDD',
                'VIO'
            ],
            supplyCurrent: [],      // uModule supply current handled by internal component supply currents
            userConfig : [
                {
                    option: { gain: 1},
                    dcErrors: {
                        'zeroScaleErrorDrift': 10,          //ppm
                        'zeroScaleErrorAtMaxTemp': 5.89824, //lsbs
                    }
                },
                {
                    option: { gain: 0.454},
                    dcErrors: {
                        'zeroScaleErrorDrift': 8,
                        'zeroScaleErrorAtMaxTemp': 2.9753344,
                    }
                },
                {
                    option: { gain: 0.909},
                    dcErrors: {
                        'zeroScaleErrorDrift': 10,
                        'zeroScaleErrorAtMaxTemp': 5.36150016,
                    }
                },
                {
                    option: { gain: 1.9},
                    dcErrors: {
                        'zeroScaleErrorDrift': 15,
                        'zeroScaleErrorAtMaxTemp': 18.67776,
                    }
                },
            ]
        },
        "ADAQ4380-4" : {
            requiredSupplyPins : [
                'VS+',
                'VS-',
                'VCC',
                'VLOGIC'
            ],
            supplyCurrent: [],      // uModule supply current handled by internal component supply currents
            userConfig : [
                {
                    option: { gain: 0.3},
                    dcErrors: {
                        'zeroScaleErrorAt25C' : 0.6, //lsbs
                        'zeroScaleErrorDrift': 0.09 //ppm
                    }
                },
                {
                    option: { gain: 0.6},
                    dcErrors: {
                        'zeroScaleErrorAt25C' : 1.19,
                        'zeroScaleErrorDrift': 0.18
                    }
                },
                {
                    option: { gain: 1},
                    dcErrors: {
                        'zeroScaleErrorAt25C' : 1.99,
                        'zeroScaleErrorDrift': 0.3
                    }
                },
                {
                    option: { gain: 1.6},
                    dcErrors: {
                        'zeroScaleErrorAt25C' : 3.18,
                        'zeroScaleErrorDrift': 0.48
                    }
                },
            ]
        },
        "ADAQ23875_ADAQ23876" : {
            requiredSupplyPins : [
                'VS+',
                'VS-',
                'VDD',
                'VIO'
            ],
            supplyCurrent: [],      // uModule supply current handled by internal component supply currents
            userConfig : [
                {
                    option: { gain: 0.37},
                    dcErrors: {
                        'inlErrorAtMaxTemp' : 1,            //lsbs
                        'zeroScaleErrorAtMaxTemp': 7.4,     //lsbs
                    }
                },
                {
                    option: { gain: 0.73},
                    dcErrors: {
                        'inlErrorAtMaxTemp' : 2,
                        'zeroScaleErrorAtMaxTemp': 14.6,
                    }
                },
                {
                    option: { gain: 0.87},
                    dcErrors: {
                        'inlErrorAtMaxTemp' : 1.2,
                        'zeroScaleErrorAtMaxTemp': 17.4,
                    }
                },
                {
                    option: { gain: 1.38},
                    dcErrors: {
                        'inlErrorAtMaxTemp' : 1.2,
                        'zeroScaleErrorAtMaxTemp': 27.6,
                    }
                },
                {
                    option: { gain: 2.25},
                    dcErrors: {
                        'inlErrorAtMaxTemp' : 1.2,
                        'zeroScaleErrorAtMaxTemp': 45,
                    }
                },
            ]
        },
        "ADAQ23878" : {
            requiredSupplyPins : [
                'VS+',
                'VS-',
                'VDD',
                'VIO'
            ],
            supplyCurrent: [],      // uModule supply current handled by internal component supply currents
            userConfig : [
                {
                    option: { gain: 0.37},
                    dcErrors: {
                        'inlErrorAtMaxTemp' : 2.5,            //lsbs
                        'zeroScaleErrorAtMaxTemp': 24.864,     //lsbs
                    }
                },
                {
                    option: { gain: 0.73},
                    dcErrors: {
                        'inlErrorAtMaxTemp' : 2,
                        'zeroScaleErrorAtMaxTemp': 49.056,
                    }
                },
                {
                    option: { gain: 0.87},
                    dcErrors: {
                        'inlErrorAtMaxTemp' : 2,
                        'zeroScaleErrorAtMaxTemp': 58.464,
                    }
                },
                {
                    option: { gain: 1.38},
                    dcErrors: {
                        'inlErrorAtMaxTemp' : 2,
                        'zeroScaleErrorAtMaxTemp': 92.736,
                    }
                },
                {
                    option: { gain: 2.25},
                    dcErrors: {
                        'inlErrorAtMaxTemp' : 2,
                        'zeroScaleErrorAtMaxTemp': 151.2,
                    }
                },
            ]
        },

        // Sigma-Delta ADCs
        "AD4129-8" : {
            requiredSupplyPins : [
                'AVDD',
                'AVSS',
                'IOVDD'
            ],
            inputRange: {
                absolute: {
                    min: {
                        delta    : -0.05,
                        referredTo: 'AVSS'
                    },
                    max: {
                        delta    : 0.05,
                        referredTo: 'AVDD'
                    }
                },
                commonMode: {
                    min: {
                        delta    : -0.05,
                        referredTo: 'AVSS'
                    },
                    max: {
                        delta    : 0.05,
                        referredTo: 'AVDD'
                    }
                },
            },
            supplyCurrentMap : {
                // Power supply name : AFM Result key
                "AVDD"  : "avdd",
                "IOVDD" : "iovdd",
                //"AVSS"  : "avss", //missing in AFM results
            },
            // NOTE:
            // DC Error section copied from AD4130-8.  Need to update with AD4129-8 data.
            // userConfig : [
            //     {
            //         option: { pgaGain: 1},
            //         dcErrors: {
            //             'zeroScaleErrorAt25C' : 33.554432,  //lsbs
            //             'zeroScaleErrorDrift': 0.046,       //ppm
            //             'fullScaleErrorDrift' : 2,          //ppm
            //             'inlErrorAt25C' : 84                //lsbs
            //         }
            //     },
            //     {
            //         option: { pgaGain: 2},
            //         dcErrors: {
            //             'zeroScaleErrorAt25C' : 67.108864,
            //             'zeroScaleErrorDrift': 0.064,
            //             'fullScaleErrorDrift' : 2,          
            //             'inlErrorAt25C' : 251.7,
                                   
            //         }
            //     },
            //     {
            //         option: { pgaGain: 4},
            //         dcErrors: {
            //             'zeroScaleErrorAt25C' : 134.217728,
            //             'zeroScaleErrorDrift': 0.1,
            //             'fullScaleErrorDrift' : 2,          
            //             'inlErrorAt25C' : 251.7 
            //         }
            //     },
            //     {
            //         option: { pgaGain: 8},
            //         dcErrors: {
            //             'zeroScaleErrorAt25C' : 268.435456,
            //             'zeroScaleErrorDrift': 0.172,
            //             'fullScaleErrorDrift' : 2,          
            //             'inlErrorAt25C' : 251.7 
            //         }
            //     },
            //     {
            //         option: { pgaGain: 16},
            //         dcErrors: {
            //             'zeroScaleErrorAt25C' : 536.870912,
            //             'zeroScaleErrorDrift': 0.316,
            //             'fullScaleErrorDrift' : 2,
            //             'inlErrorAt25C' : 251.7 
            //         }
            //     },
            //     {
            //         option: { pgaGain: 32},
            //         dcErrors: {
            //             'zeroScaleErrorAt25C' : 214.7483648,
            //             'zeroScaleErrorDrift': 0.604,
            //             'fullScaleErrorDrift' : 3,          
            //             'inlErrorAt25C' : 251.7,
                                   
            //         }
            //     },
            //     {
            //         option: { pgaGain: 64},
            //         dcErrors: {
            //             'zeroScaleErrorAt25C' : 429.4967296,
            //             'zeroScaleErrorDrift': 1.18,
            //             'fullScaleErrorDrift' : 3,          
            //             'inlErrorAt25C' : 251.7 
            //         }
            //     },
            //     {
            //         option: { pgaGain: 128},
            //         dcErrors: {
            //             'zeroScaleErrorAt25C' : 858.9934592,
            //             'zeroScaleErrorDrift': 2.332,
            //             'fullScaleErrorDrift' : 3,          
            //             'inlErrorAt25C' : 251.7 
            //         }
            //     },
            // ]
        },
        "AD4130-8" : {
            requiredSupplyPins : [
                'AVDD',
                'AVSS',
                'IOVDD'
            ],
            inputRange: {
                absolute: {
                    min: {
                        delta    : -0.05,
                        referredTo: 'AVSS'
                    },
                    max: {
                        delta    : 0.05,
                        referredTo: 'AVDD'
                    }
                },
                commonMode: {
                    min: {
                        delta    : -0.05,
                        referredTo: 'AVSS'
                    },
                    max: {
                        delta    : 0.05,
                        referredTo: 'AVDD'
                    }
                },
            },
            supplyCurrentMap : {
                // Power supply name : AFM Result key
                "AVDD"  : "avdd",
                "IOVDD" : "iovdd",
                //"AVSS"  : "avss", //missing in AFM results
            },
            userConfig : [
                {
                    option: { pgaGain: 1},
                    dcErrors: {
                        'zeroScaleErrorAt25C' : 33.554432,  //lsbs
                        'zeroScaleErrorDrift': 0.046,       //ppm
                        'fullScaleErrorDrift' : 2,          //ppm
                        'inlErrorAt25C' : 84                //lsbs
                    }
                },
                {
                    option: { pgaGain: 2},
                    dcErrors: {
                        'zeroScaleErrorAt25C' : 67.108864,
                        'zeroScaleErrorDrift': 0.064,
                        'fullScaleErrorDrift' : 2,          
                        'inlErrorAt25C' : 251.7,
                                   
                    }
                },
                {
                    option: { pgaGain: 4},
                    dcErrors: {
                        'zeroScaleErrorAt25C' : 134.217728,
                        'zeroScaleErrorDrift': 0.1,
                        'fullScaleErrorDrift' : 2,          
                        'inlErrorAt25C' : 251.7 
                    }
                },
                {
                    option: { pgaGain: 8},
                    dcErrors: {
                        'zeroScaleErrorAt25C' : 268.435456,
                        'zeroScaleErrorDrift': 0.172,
                        'fullScaleErrorDrift' : 2,          
                        'inlErrorAt25C' : 251.7 
                    }
                },
                {
                    option: { pgaGain: 16},
                    dcErrors: {
                        'zeroScaleErrorAt25C' : 536.870912,
                        'zeroScaleErrorDrift': 0.316,
                        'fullScaleErrorDrift' : 2,
                        'inlErrorAt25C' : 251.7 
                    }
                },
                {
                    option: { pgaGain: 32},
                    dcErrors: {
                        'zeroScaleErrorAt25C' : 214.7483648,
                        'zeroScaleErrorDrift': 0.604,
                        'fullScaleErrorDrift' : 3,          
                        'inlErrorAt25C' : 251.7,
                                   
                    }
                },
                {
                    option: { pgaGain: 64},
                    dcErrors: {
                        'zeroScaleErrorAt25C' : 429.4967296,
                        'zeroScaleErrorDrift': 1.18,
                        'fullScaleErrorDrift' : 3,          
                        'inlErrorAt25C' : 251.7 
                    }
                },
                {
                    option: { pgaGain: 128},
                    dcErrors: {
                        'zeroScaleErrorAt25C' : 858.9934592,
                        'zeroScaleErrorDrift': 2.332,
                        'fullScaleErrorDrift' : 3,          
                        'inlErrorAt25C' : 251.7 
                    }
                },
            ]
        },
        "AD4131-8" : {
            requiredSupplyPins : [
                'AVDD',
                'AVSS',
                'IOVDD'
            ],
            inputRange: {
                absolute: {
                    min: {
                        delta    : -0.05,
                        referredTo: 'AVSS'
                    },
                    max: {
                        delta    : 0.05,
                        referredTo: 'AVDD'
                    }
                },
                commonMode: {
                    min: {
                        delta    : -0.05,
                        referredTo: 'AVSS'
                    },
                    max: {
                        delta    : 0.05,
                        referredTo: 'AVDD'
                    }
                },
            },
            supplyCurrentMap : {
                // Power supply name : AFM Result key
                "AVDD"  : "avdd",
                "IOVDD" : "iovdd",
                //"AVSS"  : "avss", //missing in AFM results
            },
            // NOTE:
            // DC Error section copied from AD4130-8.  Need to update with AD4129-8 data.
            // userConfig : [
            //     {
            //         option: { pgaGain: 1},
            //         dcErrors: {
            //             'zeroScaleErrorAt25C' : 33.554432,  //lsbs
            //             'zeroScaleErrorDrift': 0.046,       //ppm
            //             'fullScaleErrorDrift' : 2,          //ppm
            //             'inlErrorAt25C' : 84                //lsbs
            //         }
            //     },
            //     {
            //         option: { pgaGain: 2},
            //         dcErrors: {
            //             'zeroScaleErrorAt25C' : 67.108864,
            //             'zeroScaleErrorDrift': 0.064,
            //             'fullScaleErrorDrift' : 2,          
            //             'inlErrorAt25C' : 251.7,
                                   
            //         }
            //     },
            //     {
            //         option: { pgaGain: 4},
            //         dcErrors: {
            //             'zeroScaleErrorAt25C' : 134.217728,
            //             'zeroScaleErrorDrift': 0.1,
            //             'fullScaleErrorDrift' : 2,          
            //             'inlErrorAt25C' : 251.7 
            //         }
            //     },
            //     {
            //         option: { pgaGain: 8},
            //         dcErrors: {
            //             'zeroScaleErrorAt25C' : 268.435456,
            //             'zeroScaleErrorDrift': 0.172,
            //             'fullScaleErrorDrift' : 2,          
            //             'inlErrorAt25C' : 251.7 
            //         }
            //     },
            //     {
            //         option: { pgaGain: 16},
            //         dcErrors: {
            //             'zeroScaleErrorAt25C' : 536.870912,
            //             'zeroScaleErrorDrift': 0.316,
            //             'fullScaleErrorDrift' : 2,
            //             'inlErrorAt25C' : 251.7 
            //         }
            //     },
            //     {
            //         option: { pgaGain: 32},
            //         dcErrors: {
            //             'zeroScaleErrorAt25C' : 214.7483648,
            //             'zeroScaleErrorDrift': 0.604,
            //             'fullScaleErrorDrift' : 3,          
            //             'inlErrorAt25C' : 251.7,
                                   
            //         }
            //     },
            //     {
            //         option: { pgaGain: 64},
            //         dcErrors: {
            //             'zeroScaleErrorAt25C' : 429.4967296,
            //             'zeroScaleErrorDrift': 1.18,
            //             'fullScaleErrorDrift' : 3,          
            //             'inlErrorAt25C' : 251.7 
            //         }
            //     },
            //     {
            //         option: { pgaGain: 128},
            //         dcErrors: {
            //             'zeroScaleErrorAt25C' : 858.9934592,
            //             'zeroScaleErrorDrift': 2.332,
            //             'fullScaleErrorDrift' : 3,          
            //             'inlErrorAt25C' : 251.7 
            //         }
            //     },
            // ]
        },
        "AD4134" : {
            requiredSupplyPins : [
                'AVDD5',
                'DVDD5',
                'IOVDD',
                'DVDD1V8',
                'AVDD1V8',
                'CLKVDD',
            ],
            inputRange: {
                absolute: {
                    min: {
                        delta    : -0.1,
                        referredTo: 'GND'
                    },
                    max: {
                        delta    : 0.1,
                        referredTo: 'AVDD5'
                    }
                },
                commonMode: {
                    min: {
                        delta    : 0,
                        referredTo: 'GND'
                    },
                    max: {
                        delta    : 0,
                        multiplier: 0.5,
                        referredTo: 'AVDD5'
                    }
                },
            },
            supplyCurrentMap : {
                // Power supply name : AFM Result key
                "AVDD5"   : "avdd5",
                "DVDD5"   : "dvdd5",
                "IOVDD"   : "iovdd",
                "DVDD1V8" : "dvdd1v8",
                "AVDD1V8" : "avdd1v8",
                "CLKVDD"  : "clkvdd",
            },
            userConfig : [
                {
                    option: { powerMode: 'highPerformance'},
                    dcErrors: {
                        'zeroScaleErrorDrift': 0.45,       //ppm
                    }
                },
                {
                    option: { powerMode: 'lowPower'},
                    dcErrors: {
                        'zeroScaleErrorDrift': 0.37,       //ppm
                    }
                },
            ]
        },
        "AD7172-2" : {
            requiredSupplyPins : [
                'AVDD1',
                'AVDD2',
                'AVSS',
                'IOVDD'
            ],
            inputRange: {
                absolute: {
                    min: {
                        delta    : -0.05,
                        referredTo: 'AVSS'
                    },
                    max: {
                        delta    : 0.05,
                        referredTo: 'AVDD1'
                    }
                },
                commonMode: {
                    min: {
                        delta    : -0.05,
                        referredTo: 'AVSS'
                    },
                    max: {
                        delta    : 0.05,
                        referredTo: 'AVDD1'
                    }
                },
            },
            supplyCurrentMap : {
                // Power supply name : AFM Result key
                "AVDD1" : "aIdd1",
                "AVDD2" : "aIdd2",
                "IOVDD" : "dIdd",
            }
        },
        "AD7172-4" : {
            requiredSupplyPins : [
                'AVDD1',
                'AVDD2',
                'AVSS',
                'IOVDD'
            ],
            inputRange: {
                absolute: {
                    min: {
                        delta    : -0.05,
                        referredTo: 'AVSS'
                    },
                    max: {
                        delta    : 0.05,
                        referredTo: 'AVDD1'
                    }
                },
                commonMode: {
                    min: {
                        delta    : -0.05,
                        referredTo: 'AVSS'
                    },
                    max: {
                        delta    : 0.05,
                        referredTo: 'AVDD1'
                    }
                },
            },
            supplyCurrentMap : {
                // Power supply name : AFM Result key
                "AVDD1" : "aIdd1",
                "AVDD2" : "aIdd2",
                "IOVDD" : "dIdd",
            }
        },
        "AD7173-8" : {
            requiredSupplyPins : [
                'AVDD1',
                'AVDD2',
                'AVSS',
                'IOVDD'
            ],
            inputRange: {
                absolute: {
                    min: {
                        delta    : 0,
                        referredTo: 'AVSS'
                    },
                    max: {
                        delta    : -1.1,
                        referredTo: 'AVDD1'
                    }
                },
                commonMode: {
                    min: {
                        delta    : 0,
                        referredTo: 'AVSS'
                    },
                    max: {
                        delta    : -1.1,
                        referredTo: 'AVDD1'
                    }
                },
            },
            supplyCurrentMap : {
                // Power supply name : AFM Result key
                "AVDD1" : "aIdd1",
                "AVDD2" : "aIdd2",
                "IOVDD" : "dIdd",
            }
        },
        "AD7175-2" : {
            requiredSupplyPins : [
                'AVDD1',
                'AVDD2',
                'AVSS',
                'IOVDD'
            ],
            inputRange: {
                absolute: {
                    min: {
                        delta    : 0,
                        referredTo: 'AVSS'
                    },
                    max: {
                        delta    : 0,
                        referredTo: 'AVDD1'
                    }
                },
                commonMode: {
                    min: {
                        delta    : 0,
                        referredTo: 'AVSS'
                    },
                    max: {
                        delta    : 0,
                        referredTo: 'AVDD1'
                    }
                },
            },
            supplyCurrentMap : {
                // Power supply name : AFM Result key
                "AVDD1" : "aIdd1",
                "AVDD2" : "aIdd2",
                "IOVDD" : "dIdd",
            }
        },
        "AD7175-8" : {
            requiredSupplyPins : [
                'AVDD1',
                'AVDD2',
                'AVSS',
                'IOVDD'
            ],
            inputRange: {
                absolute: {
                    min: {
                        delta    : 0,
                        referredTo: 'AVSS'
                    },
                    max: {
                        delta    : 0,
                        referredTo: 'AVDD1'
                    }
                },
                commonMode: {
                    min: {
                        delta    : 0,
                        referredTo: 'AVSS'
                    },
                    max: {
                        delta    : 0,
                        referredTo: 'AVDD1'
                    }
                },
            },
            supplyCurrentMap : {
                // Power supply name : AFM Result key
                "AVDD1" : "aIdd1",
                "AVDD2" : "aIdd2",
                "IOVDD" : "dIdd",
            }
        },
        "AD7177-2" : {
            requiredSupplyPins : [
                'AVDD1',
                'AVDD2',
                'AVSS',
                'IOVDD'
            ],
            inputRange: {
                absolute: {
                    min: {
                        delta    : 0,
                        referredTo: 'AVSS'
                    },
                    max: {
                        delta    : 0,
                        referredTo: 'AVDD1'
                    }
                },
                commonMode: {
                    min: {
                        delta    : 0,
                        referredTo: 'AVSS'
                    },
                    max: {
                        delta    : 0,
                        referredTo: 'AVDD1'
                    }
                },
            },
            supplyCurrentMap : {
                // Power supply name : AFM Result key
                "AVDD1" : "aIdd1",
                "AVDD2" : "aIdd2",
                "IOVDD" : "dIdd",
            }
        },
        "AD7768-1" : {
            requiredSupplyPins : [
                'AVDD1',
                'AVDD2',
                'AVSS',
                'IOVDD'
            ],
            inputRange: {
                absolute: {
                    min: {
                        delta    : -0.05,
                        referredTo: 'AVSS'
                    },
                    max: {
                        delta    : 0.05,
                        referredTo: 'AVDD1'
                    }
                },
                commonMode: {
                    min: {
                        delta    : -0.05,
                        referredTo: 'AVSS'
                    },
                    max: {
                        delta    : 0.05,
                        referredTo: 'AVDD1'
                    }
                },
            },
            supplyCurrentMap : {
                // Power supply name : AFM Result key
                // These names may be wrong - update when AFM API call is fixed
                "AVDD1" : "avdd1",
                "AVDD2" : "avdd2",
                // "AVSS"  : "aIss",
                "IOVDD" : "iOvdd",
            },
            dcErrors: {
                'RefIbias': 300e-9,
                'RefIbiasTC': 4e-9, // Amps / degrees C
            }
        },
        "ADAQ7768-1" : {
            requiredSupplyPins : [
                'VDD_PGA',
                'VSS_PGA',
                'VDD2_PGA',
                'VDD_FDA',
                'VDD_ADC',
                'VDD2_ADC',
                'VDD_IO',
            ],
            supplyCurrentMap : {
                // Power supply name : AFM Result key
                "VDD_ADC" : "avdd1",
                "VDD2_ADC" : "avdd2",
                // "AVSS"  : "aIss",
                "VDD_IO" : "iOvdd",
            },
            userConfig : [
                {
                    option: { gain: 0.325},
                    dcErrors: {
                        'inlErrorAt25C': 18, //lsbs
                        'zeroScaleErrorAt25C' : 3860, //lsbs
                        'zeroScaleErrorDrift': 2.4, //ppm
                        'RefIbias': 300e-9,
                        'RefIbiasTC': 4e-9, // Amps / degrees C
                    }
                },
                {
                    option: { gain: 0.65},
                    dcErrors: {
                        'inlErrorAt25C': 17, 
                        'zeroScaleErrorAt25C' : 3860,
                        'zeroScaleErrorDrift': 2.5,
                        'RefIbias': 300e-9,
                        'RefIbiasTC': 4e-9,
                    }
                },
                {
                    option: { gain: 1.3},
                    dcErrors: {
                        'inlErrorAt25C': 17, 
                        'zeroScaleErrorAt25C' : 5590,
                        'zeroScaleErrorDrift': 2.5,
                        'RefIbias': 300e-9,
                        'RefIbiasTC': 4e-9, 
                    }
                },
                {
                    option: { gain: 2.6},
                    dcErrors: {
                        'inlErrorAt25C': 18, 
                        'zeroScaleErrorAt25C' : 7450,
                        'zeroScaleErrorDrift': 2.7,
                        'RefIbias': 300e-9,
                        'RefIbiasTC': 4e-9,
                    }
                },
                {
                    option: { gain: 5.2},
                    dcErrors: {
                        'inlErrorAt25C': 19, 
                        'zeroScaleErrorAt25C' : 10600,
                        'zeroScaleErrorDrift': 3.2,
                        'RefIbias': 300e-9,
                        'RefIbiasTC': 4e-9,
                    }
                },
                {
                    option: { gain: 10.4},
                    dcErrors: {
                        'inlErrorAt25C': 22, 
                        'zeroScaleErrorAt25C' : 17000,
                        'zeroScaleErrorDrift': 3.8,
                        'RefIbias': 300e-9,
                        'RefIbiasTC': 4e-9,
                    }
                },
                {
                    option: { gain: 20.8},
                    dcErrors: {
                        'inlErrorAt25C': 30, 
                        'zeroScaleErrorAt25C' : 29800,
                        'zeroScaleErrorDrift': 5.6,
                        'RefIbias': 300e-9,
                        'RefIbiasTC': 4e-9,
                    }
                }
            ]
        },
    }
}